export enum AttachmentDocumentType {
  PASSPORT_ID_OR_DRIVER_LICENCE = "PASSPORT_ID_OR_DRIVER_LICENCE",
  PASSPORT_OR_ID = "PASSPORT_OR_ID",
  SWISS_ALIENS_CARD = "SWISS_ALIENS_CARD",
  EMPLOYMENT_CONTRACT = "EMPLOYMENT_CONTRACT",
  AUTHENTICITY_PROOF = "AUTHENTICITY_PROOF",
  COMMERCIAL_REGISTER_EXTRACT = "COMMERCIAL_REGISTER_EXTRACT",
  FOUNDING_DOCUMENTS_OR_EQUIVALENT = "FOUNDING_DOCUMENTS_OR_EQUIVALENT",
  ANNUAL_REPORT = "ANNUAL_REPORT",
}
